import { Activity, ActivityContentSpaceMemberRemoved } from "@/api";
import { shortName } from "@/models/people";

import { feedTitle, spaceLink } from "../feedItemLinks";
import { ActivityHandler } from "../interfaces";

const SpaceMemberRemoved: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(paths, activity: Activity): string {
    return paths.spacePath(content(activity).space!.id!);
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity, page }: { activity: Activity; page: any }) {
    const person = shortName(content(activity).member!);
    const space = spaceLink(content(activity).space!);

    if (page === "пространство") {
      return feedTitle(activity, "удалил(а)", person, "из пространства");
    } else {
      return feedTitle(activity, "удалил(а)", person, "из", space, "пространство");
    }
  },

  FeedItemContent(_props: { activity: Activity; page: any }) {
    return null;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  NotificationLocation(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },
};

export default SpaceMemberRemoved;

function content(activity: Activity): ActivityContentSpaceMemberRemoved {
  return activity.content as ActivityContentSpaceMemberRemoved;
}
